import { useToLocalizedPath } from 'hooks/useToLocalizedPath/useToLocalizedPath';
import { useMatch } from 'react-router-dom';
import { RoutePaths } from 'types/enums';

export const useDownloadsPageMatch = (): { isDownloadsPage: boolean } => {
    const toLocalizedPath = useToLocalizedPath();
    const match = useMatch(toLocalizedPath(`/${RoutePaths.Downloads}`));

    const isDownloadsPage =
        !!match &&
        match.pathname === toLocalizedPath(`/${RoutePaths.Downloads}`);

    return { isDownloadsPage };
};
